import {
    FETCH_PHYSICIANS_REQUEST, FETCH_PHYSICIANS_SUCCESS, FETCH_PHYSICIANS_FAILURE,
    CREATE_PHYSICIAN_SUCCESS, UPDATE_PHYSICIAN_SUCCESS, DELETE_PHYSICIAN_SUCCESS
  } from '../actions/physicianActions';
  
  const initialState = {
    physicians: [],
    loading: false,
    error: null,
  };
  
  export default function physicianReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_PHYSICIANS_REQUEST:
        return { ...state, loading: true };
      case FETCH_PHYSICIANS_SUCCESS:
        return { ...state, loading: false, physicians: action.payload };
      case CREATE_PHYSICIAN_SUCCESS:
        return { ...state, physicians: [...state.physicians, action.payload] };
      case UPDATE_PHYSICIAN_SUCCESS:
        return {
          ...state,
          physicians: state.physicians.map((physician) =>
            physician.id === action.payload.id ? action.payload : physician
          ),
        };
      case DELETE_PHYSICIAN_SUCCESS:
        return {
          ...state,
          physicians: state.physicians.filter((physician) => physician.id !== action.payload),
        };
      default:
        return state;
    }
  }
  